import React, { useEffect, useState } from 'react'
import ClipLoader from 'react-spinners/ClipLoader'
import { API_URL } from './config'
import './Cancelled.css'

const Cancelled = () => {
  const [missingParams, setMissingParams] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const requiredParams = [
      'ticket_number',
      'ticket_id',
      'event_id',
      'business_id',
      'name_first',
      'name_last',
      'email',
      'item_name',
      'admission',
      'customer_id',
    ]

    const urlParams = new URLSearchParams(window.location.search)

    const missing = requiredParams.filter((param) => {
      const value = urlParams.get(param)
      return value === null || value.trim() === ''
    })
    setMissingParams(missing)

    if (missing.length > 0) {
      setLoading(false)
    }

    if (localStorage.getItem('businessid')) {
      setLoading(false)
    }
  }, [])

  const urlParams = new URLSearchParams(window.location.search)
  const ticketId = urlParams.get('ticket_id')
  const eventId = urlParams.get('event_id')
  const businessId = urlParams.get('business_id')
  const campaignId = urlParams.get('campaign_id')
  const ticketNumber = urlParams.get('ticket_number')
  const nameFirst = urlParams.get('name_first')
  const nameLast = urlParams.get('name_last')
  const email = urlParams.get('email')
  const itemName = urlParams.get('item_name')
  const admission = urlParams.get('admission')
  const customerId = urlParams.get('customer_id')
  const group = urlParams.get('group')
  const amount = urlParams.get('amount')

  useEffect(() => {
    if (
      ticketId &&
      eventId &&
      businessId &&
      ticketNumber &&
      nameFirst &&
      nameLast &&
      email &&
      itemName
    ) {
      let apiUrl

      if (localStorage.getItem('businessid')) {
        apiUrl = `${API_URL}/apps/kscanner/webservices.php?query=CAMPAIGN-PAYMENT-CANCELLATION&event_id=${eventId}&business_id=${businessId}&campaign_id=${campaignId}&amount=${amount}`
      } else {
        apiUrl = `${API_URL}/apps/kscanner/webservices.php?query=CANCELLATION&ticket_id=${ticketId}&event_id=${eventId}&business_id=${businessId}&ticket_number=${ticketNumber}&name_first=${nameFirst}&name_last=${nameLast}&email=${email}&item_name=${itemName}&admission=${admission}&customer_id=${customerId}&group=${group}&amount=${amount}`
      }

      fetch(apiUrl)
        .then((response) => response.json())
        .then((data) => {
          setLoading(false)
          if (data.success) {
            console.log('Ticket cancellation successful:', data)
          } else {
            console.error('Cancellation failed:', data)
          }
        })
        .catch((error) => {
          console.error('Error processing ticket cancellation:', error)
        })
    }
  }, [])

  const homeHref = localStorage.getItem('businessid') ? '/dashboard' : '/customerdashboard'

  return (
    <div className="cx-page">
      <div className="cx-card" role="status" aria-live="polite">
        {loading && (
          <>
            <div className="cx-spinner">
              <ClipLoader size={34} color="#ff5a36" />
            </div>
            <h1 className="cx-title">Processing your cancellation</h1>
            <p className="cx-text">Hold on, this will only take a moment.</p>
          </>
        )}

        {!loading && missingParams.length > 0 && (
          <>
            <div className="cx-icon cx-icon--warn">
              <svg
                width="30"
                height="30"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
              >
                <path d="M12 3l10 18H2L12 3z" />
                <path d="M12 10v4M12 17.5v.01" />
              </svg>
            </div>
            <h1 className="cx-title">Something's missing</h1>
            <p className="cx-text">We couldn't find some details needed to process this page:</p>
            <div className="cx-chips">
              {missingParams.map((param) => (
                <span key={param} className="cx-chip">
                  {param}
                </span>
              ))}
            </div>
            <a href={homeHref} className="cx-btn">
              Return home
            </a>
          </>
        )}

        {!loading && missingParams.length === 0 && (
          <>
            <div className="cx-icon cx-icon--bad">
              <svg
                width="30"
                height="30"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.2"
                strokeLinecap="round"
                aria-hidden="true"
              >
                <circle cx="12" cy="12" r="9" />
                <path d="M9 9l6 6M15 9l-6 6" />
              </svg>
            </div>
            <h1 className="cx-title">Payment cancelled</h1>
            <p className="cx-text">
              Your payment has been cancelled.
              <br />
              You haven't been charged.
            </p>
            <a href={homeHref} className="cx-btn">
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
              >
                <path d="M3 11l9-8 9 8" />
                <path d="M5 10v10h5v-6h4v6h5V10" />
              </svg>
              Return home
            </a>
          </>
        )}
      </div>
    </div>
  )
}

export default Cancelled
